var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgEmailForgot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_110_578",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_110_578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6663 53.3333C9.19967 53.3333 7.94412 52.8111 6.89967 51.7666C5.85523 50.7222 5.33301 49.4666 5.33301 48V16C5.33301 14.5333 5.85523 13.2777 6.89967 12.2333C7.94412 11.1888 9.19967 10.6666 10.6663 10.6666H53.333C54.7997 10.6666 56.0552 11.1888 57.0997 12.2333C58.1441 13.2777 58.6663 14.5333 58.6663 16V48C58.6663 49.4666 58.1441 50.7222 57.0997 51.7666C56.0552 52.8111 54.7997 53.3333 53.333 53.3333H10.6663ZM31.9997 34.2C32.2219 34.2 32.4552 34.1666 32.6997 34.1C32.9441 34.0333 33.1775 33.9333 33.3997 33.8L52.2663 22C52.6219 21.7777 52.8886 21.5 53.0663 21.1666C53.2441 20.8333 53.333 20.4666 53.333 20.0666C53.333 19.1777 52.9552 18.5111 52.1997 18.0666C51.4441 17.6222 50.6663 17.6444 49.8663 18.1333L31.9997 29.3333L14.133 18.1333C13.333 17.6444 12.5552 17.6333 11.7997 18.1C11.0441 18.5666 10.6663 19.2222 10.6663 20.0666C10.6663 20.5111 10.7552 20.9 10.933 21.2333C11.1108 21.5666 11.3775 21.8222 11.733 22L30.5997 33.8C30.8219 33.9333 31.0552 34.0333 31.2997 34.1C31.5441 34.1666 31.7775 34.2 31.9997 34.2Z",
    fill: "#FC5900"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailForgot);
export default __webpack_public_path__ + "static/media/email-forgot.c179c52ea279e53e1d340760adb9539d.svg";
export { ForwardRef as ReactComponent };